import { svgSprite } from '../../../../../hybrid/wrappers';
import css from './GridTheadSort.module.scss';
import classnames from 'classnames';

const GridTheadSort = ({ sortData }) => {
    const { func } = sortData;
    return (
        <div onClick={func} className={css.sortIcon}>
            {/* {svgSprite(active === 'up' ? 'sort-up' : 'sort-down', { */}
            {svgSprite('sort', {
                // className: classnames(css.sortIconSvg, active ? css.sortIconSvgActive : {})
                className: classnames(css.sortIconSvg)
            })}
        </div>
    );
};
export default GridTheadSort;
